import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import Sport from './Components/Sport/Sport';
import SportsDetail from './Components/SportsDetail/SportsDetail';




function App() {
  
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/home">
            <Sport />
          </Route>
          <Route path="/sports/:explore">
            <SportsDetail />          
          </Route>
          <Route exact path="/">
          <Sport />
          </Route>
        </Switch>
      </Router>
      
    </div>
  );
}

export default App;
